import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Button,
  Spin,
  Modal,
  Tag,
  message,
} from "antd";
import axios from "axios";

const { Title } = Typography;

const ManageProductTags = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tagModalVisible, setTagModalVisible] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [newKeyword, setNewKeyword] = useState("");

  // Fetch categories on mount
  useEffect(() => {
    fetchCategories();
    checkUserActiveStatus();
  }, []);

  const checkUserActiveStatus = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          if (
            response.data.IsActive === false ||
            response.data.IsDeleted === false ||
            response.data.IsEmployee !== true // <-- Only allow if IsEmployee is true
          ) {
            alert("You are not authorized to access this page.");
            localStorage.removeItem("token");
            localStorage.removeItem("userName");
            window.location.href = "/"; // <-- Redirect to home
          }
        })
        .catch((error) => {});
    } catch (error) {}
  };

  // Fetch products when category changes
  useEffect(() => {
    if (selectedCategory) {
      fetchProducts(selectedCategory);
    }
  }, [selectedCategory]);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const tokenString = localStorage.getItem("token");
      const response = await axios.get(
        global.config.APIURL.BaseURL +
          "api/ProductCategory/ListofProductCategory",
        {
          headers: {
            Authorization: "Bearer " + tokenString,
          },
        }
      );
      // Flatten category data if needed
      const allCategories = response.data.flatMap((cat) => cat.data);
      setCategories(allCategories);
      if (allCategories.length > 0) {
        setSelectedCategory(allCategories[0].ProductCategoryID);
      }
    } catch (error) {
      message.error("Failed to fetch categories.");
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async (categoryID) => {
    setLoading(true);
    try {
      const tokenString = localStorage.getItem("token");
      const response = await axios.get(
        global.config.APIURL.BaseURL +
          "api/Product/ListofProductByCategoryforList?CategoryID=" +
          categoryID,
        {
          headers: {
            Authorization: "Bearer " + tokenString,
          },
        }
      );
      setProducts(response.data || []);
    } catch (error) {
      message.error("Failed to fetch products.");
    } finally {
      setLoading(false);
    }
  };

  // Open modal to manage tags
  const openTagModal = (product) => {
    setSelectedProduct(product);
    setTagModalVisible(true);
  };

  // Placeholder for tag management UI
  const TagManagementModal = () => (
    <Modal
      open={tagModalVisible}
      onCancel={() => setTagModalVisible(false)}
      footer={null}
      title={`Manage Key Words for ${selectedProduct?.ProductName || ""}`}
      centered
      destroyOnClose
    >
      <div>
        <p style={{ marginBottom: 4 }}>Tags:</p>
        <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
          <input
            type="text"
            value={selectedProduct?.Tag1 || ""}
            readOnly
            style={{
              flex: 1,
              padding: "4px 8px",
              border: "1px solid #d9d9d9",
              borderRadius: 4,
              color: "#555",
              background: "#fafafa",
            }}
            placeholder="Tag1"
          />
          <input
            type="text"
            value={selectedProduct?.Tag2 || ""}
            readOnly
            style={{
              flex: 1,
              padding: "4px 8px",
              border: "1px solid #d9d9d9",
              borderRadius: 4,
              color: "#555",
              background: "#fafafa",
            }}
            placeholder="Tag2"
          />
        </div>
        <div style={{ marginBottom: 8 }}>
          <p style={{ marginBottom: 4 }}>Add Key Word:</p>
          <input
            type="text"
            value={newKeyword}
            onChange={(e) => setNewKeyword(e.target.value)}
            style={{
              width: "100%",
              padding: "4px 8px",
              border: "1px solid #d9d9d9",
              borderRadius: 4,
              marginBottom: 8,
            }}
            placeholder="Enter new key word"
          />
          {/* You can add a button here to handle adding the keyword */}
        </div>
        <div style={{ marginBottom: 8 }}>
          <p style={{ marginBottom: 4 }}>Assigned Key Words:</p>
          {selectedProduct?.Tags && selectedProduct.Tags.length > 0 ? (
            selectedProduct.Tags.map((tag) => <Tag key={tag}>{tag}</Tag>)
          ) : (
            <span>No key words assigned.</span>
          )}
        </div>
        <div style={{ marginTop: 16, color: "#888" }}>
          (Key word management UI goes here)
        </div>
      </div>
    </Modal>
  );

  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", padding: 8 }}>
      <Card
        style={{
          borderRadius: 16,
          boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
          background: "#fff",
          margin: 0,
        }}
        styles={{ padding: 16 }}
      >
        <Title level={2} style={{ textAlign: "center", marginBottom: 24 }}>
          Manage Product Key Words
        </Title>
        <Row gutter={16}>
          {/* Left: Categories */}
          <Col xs={24} sm={6} md={5} lg={5} style={{ minWidth: 150 }}>
            <Card
              style={{
                marginBottom: 0,
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
                background: "#fafafa",
              }}
              styles={{ padding: 16 }}
            >
              <Title
                level={4}
                style={{
                  marginBottom: 12,
                  fontSize: 18,
                  textAlign: "left",
                }}
              >
                Categories
              </Title>
              {categories.map((cat) => (
                <Button
                  key={cat.ProductCategoryID}
                  type={
                    String(selectedCategory) === String(cat.ProductCategoryID)
                      ? "primary"
                      : "text"
                  }
                  block
                  style={{
                    marginBottom: 8,
                    textAlign: "left",
                    justifyContent: "flex-start",
                    display: "flex",
                  }}
                  onClick={() => setSelectedCategory(cat.ProductCategoryID)}
                >
                  {cat.CategoryName}
                </Button>
              ))}
            </Card>
          </Col>
          {/* Right: Products */}
          <Col xs={24} sm={18} md={19} lg={19}>
            {loading ? (
              <div style={{ textAlign: "center", padding: 40 }}>
                <Spin size="large" />
              </div>
            ) : (
              <Row gutter={[16, 16]}>
                {products.map((product) => (
                  <Col xs={24} sm={12} md={8} lg={6} key={product.ProductID}>
                    <Card
                      hoverable
                      style={{
                        borderRadius: 8,
                        boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                        marginBottom: 0,
                      }}
                      cover={
                        product.ImageUrl && (
                          <img
                            alt={product.ProductName}
                            src={product.ImageUrl}
                            style={{
                              height: 160,
                              objectFit: "cover",
                              borderTopLeftRadius: 8,
                              borderTopRightRadius: 8,
                            }}
                          />
                        )
                      }
                    >
                      <Title
                        level={5}
                        style={{ margin: 0, fontSize: 13, fontWeight: 500 }}
                      >
                        {product.ProductName}
                      </Title>
                      <div style={{ margin: "8px 0" }}>
                        {product.Tags && product.Tags.length > 0
                          ? product.Tags.map((tag) => (
                              <Tag key={tag}>{tag}</Tag>
                            ))
                          : (product.Tag1 || product.Tag2) && (
                              <>
                                {product.Tag1 && (
                                  <span
                                    style={{ color: "#888", marginRight: 8 }}
                                  >
                                    {product.Tag1}
                                  </span>
                                )}
                                {product.Tag2 && (
                                  <span style={{ color: "#888" }}>
                                    {product.Tag2}
                                  </span>
                                )}
                              </>
                            )}
                      </div>
                      <Button
                        type="primary"
                        block
                        onClick={() => openTagModal(product)}
                      >
                        Manage Key Words
                      </Button>
                    </Card>
                  </Col>
                ))}
              </Row>
            )}
          </Col>
        </Row>
      </Card>
      {tagModalVisible && <TagManagementModal />}
    </div>
  );
};

export default ManageProductTags;
